import { render, staticRenderFns } from "./GBaseButton.vue?vue&type=template&id=7742c40a&scoped=true&"
import script from "./GBaseButton.vue?vue&type=script&lang=ts&"
export * from "./GBaseButton.vue?vue&type=script&lang=ts&"
import style0 from "./GBaseButton.vue?vue&type=style&index=0&id=7742c40a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7742c40a",
  null
  
)

export default component.exports